import React, { useCallback } from 'react';
import { translate } from '@utils/i18n';
import DetailSection from '@components/v2/DetailSection';
import RelatedItems from '@components/v2/RelatedItems';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import Accordion from '@components/v2/Accordion';
import { InlineEdit } from '@components/v2/InlineEdit';
import { namespace } from '../../constants';
import KeyValueList from '../KeyValueList';
import useDeficiencyDetail from '../../../hooks/useDeficiencyDetail';
import useUpdateDeficiencyDetail from '../../../hooks/useUpdateDeficiency';
import { getAssetsInfo, getGeneralInfo } from './getGeneralInfo';
export default function DetailInfo({ id }) {
    const { updateDeficiency } = useUpdateDeficiencyDetail();
    const handleContentChange = useCallback((field, value) => {
        if (value === '--')
            return;
        updateDeficiency.mutate({
            id,
            deficiencyUpdate: { [field]: value }
        });
    }, [id, updateDeficiency]);
    const { data: deficiency, isLoading, error } = useDeficiencyDetail(id);
    if (isLoading) {
        return React.createElement(Loader, { size: LoaderSizes.large });
    }
    if (error || !deficiency) {
        return React.createElement("div", null, translate('def_error_message', { namespace }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DetailSection, { title: translate('tabs.detail.related', { namespace }) },
            React.createElement(RelatedItems, { items: deficiency.relatedItems.map((item) => ({
                    label: item.name,
                    labelClass: item.icon,
                    items: item.items.map((relatedItem) => ({
                        display: relatedItem.label,
                        path: relatedItem.path
                    }))
                })) })),
        React.createElement(DetailSection, { title: translate('tabs.detail.general_information', { namespace }) },
            React.createElement("div", { className: "row-fluid" },
                React.createElement("div", { className: "span6" },
                    React.createElement("div", { className: "row-fluid" },
                        React.createElement(KeyValueList, { items: getGeneralInfo(deficiency), onEdit: handleContentChange })),
                    React.createElement("div", { className: "row-fluid", style: { padding: '10px 0 10px 0' } },
                        React.createElement(Accordion, { title: "Internal Notes" },
                            React.createElement(InlineEdit, { variant: "x-full", placeholder: "Enter text...", onBlur: (e) => {
                                    const value = e.currentTarget.textContent || '';
                                    if (value !== deficiency.internalNote)
                                        handleContentChange('internalNote', value);
                                } }, deficiency.internalNote))),
                    React.createElement("div", { className: "row-fluid", style: { padding: '10px 0 10px 0' } },
                        React.createElement(Accordion, { title: "Notes" },
                            React.createElement(InlineEdit, { variant: "x-full", placeholder: "Enter text...", onBlur: (e) => {
                                    const value = e.currentTarget.textContent || '';
                                    if (value !== deficiency.note)
                                        handleContentChange('note', value);
                                } }, deficiency.note))),
                    (deficiency === null || deficiency === void 0 ? void 0 : deficiency.isResolved) && (React.createElement("div", { className: "row-fluid", style: { padding: '10px 0 10px 0' } },
                        React.createElement(Accordion, { title: "Resolution Notes" },
                            React.createElement(InlineEdit, { variant: "x-full", placeholder: "Enter text...", onBlur: (e) => {
                                    const value = e.currentTarget.textContent || '';
                                    if (value !== deficiency.resolutionNotes)
                                        handleContentChange('resolutionNotes', value);
                                } }, deficiency.resolutionNotes))))),
                getAssetsInfo(deficiency).length > 0 && (React.createElement("div", { className: "span6", style: { paddingLeft: '18px', border: '1px solid #ccc' } },
                    React.createElement(KeyValueList, { items: getAssetsInfo(deficiency) })))))));
}
